<template>
  <template v-for="item in structuredContent" :key="JSON.stringify(item)">
    <CmsPageContentBlock
      v-bind="{
        block: item,
      }"
    />
  </template>
</template>
<script lang="ts" setup>
import * as Sentry from "@sentry/vue";

const props = defineProps<{
  id: string;
}>();

const token = ref();

$fetch(`/api/contentElement`, {
  params: { id: props.id, type: "token" },
})
  .then((tokenData) => {
    token.value = tokenData;
  })
  .catch((error) => {
    Sentry.captureEvent({
      message: `Failed to fetch content element`,
      level: "error",
      extra: {
        key: "ER-O7NN",
        id: props.id,
        type: "token",
        error,
      },
    });
  });

const structuredContent = computed(() => {
  if (token.value?.data?.data?.content?.pages) {
    return token.value.data.data.content.pages[0].frames[0].component
      .components;
  }
});
</script>
